// react redux
import { useSelector } from 'react-redux'
// formik
import { useFormik } from 'formik'
import { addCitySchema } from '../../../schemes/city/addCitySchema'
// axios
import enhancedAxios from '../../../utils/axiosUtils/enhancedAxios'
// components
import { PageTitle, MainButton, ErrorMessage } from '../../../components'
// mui
import { Stack, TextField, FormControlLabel, Checkbox } from '@mui/material'
// alerts
import { successAlert, errorAlert } from '../../../utils/alerts'
const AddCity = () => {
    const userToken = useSelector((state) => state.userToken)
    const onSubmit = (values) => {
        const formData = new FormData()
        for (let i in values) {
            formData.append(i, values[i])
        }

        enhancedAxios('multipart/form-data', userToken)
            .post(`/admin/cities`, formData)
            .then((response) => {
                successAlert('تم اضافة المدينة')
                setSubmitting(false)
                resetForm()
            })
            .catch((error) => errorAlert(error))
    }
    // formik configration
    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        isSubmitting,
        setSubmitting,
        resetForm,
    } = useFormik({
        initialValues: {
            name: '',
            is_disabled: false,
        },
        validationSchema: addCitySchema,
        onSubmit, //function we write above
    })
    return (
        <Stack width="100%" height="100%" spacing={8} alignItems="center">
            <PageTitle title="إضافة مدينة" />
            <Stack
                component="form"
                spacing={2}
                onSubmit={handleSubmit}
                width="100%"
                maxWidth="600px"
            >
                <TextField
                    name="name"
                    value={values.name}
                    label="اسم المدينة"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    sx={{
                        width: '100%',
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={values.is_disabled}
                            onChange={handleChange}
                            name="is_disabled"
                        />
                    }
                    label="اخفاء المقال"
                />
                {/* submit button */}
                <MainButton text="إنشاء" disabled={isSubmitting} />
                {errors && (
                    <Stack spacing={1}>
                        {errors.name && touched.name && (
                            <ErrorMessage errorMsg={errors.name} />
                        )}
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}

export default AddCity
